module.exports = __webpack_public_path__ + "img/missing_soap.08edcd6a.svg";